<template>
    <form class="card">
        <h3>Транзакции владельца</h3>
        <div class="grid _free mtop" v-if="status == ''">
            <div class="inline">
                <div class="grid">
                    <div class="text-item finance" v-if="data.diff_begin">
                        <span>Сальдо на начало</span>
                        <p :class="{negative: parseFloat(data.diff_begin) < 0}">{{ data.diff_begin | finance }}</p>
                    </div>
                    <div class="text-item finance" v-if="data.income">
                        <span>Доход</span>
                        <p>{{ data.income | finance }}</p>
                    </div>
                    <div class="text-item finance" v-if="data.outcome">
                        <span>Заплачено</span>
                        <p>{{ data.outcome | finance }}</p>
                    </div>
                    <div class="text-item finance" v-if="data.diff">
                        <span>Сальдо на конец</span>
                        <p :class="{negative: parseFloat(data.diff) < 0}">{{ data.diff | finance }}</p>
                    </div>
                </div>

                <div class="grid">
                    <div class="text-item" v-if="data.email_mercado_pago.length">
                        <span>Mercado Pago email</span>
                        <p>{{ data.email_mercado_pago[0] }}</p>
                    </div>
                    <div class="form-item">
                        <label for="pay_sum">Сумма оплаты</label>
                        <input type="text" id="pay_sum" class="text-input" v-model="pay_sum">
                    </div>
                    <div class="button _free _accept form-item" :class="{disabled: pay_sum == ''}" @click="$emit('showPopup', {popup: 'confirm', text: pay_sum})">Оплатить</div>
                </div>

                <div class="grid">
                    <div class="text-item short" v-if="data.transaction_count">
                        <span>Транзакций</span>
                        <p>{{ data.transaction_count }}</p>
                    </div>
                    <div class="text-item short" v-if="data.cancelled">
                        <span>Отменено</span>
                        <p>{{ data.cancelled }}</p>
                    </div>
                </div>
            </div>

            <div class="grid _free mtop"  v-if="data.parkings && data.parkings.length > 1">
                <table class="table-light">
                    <thead>
                    <td>адрес</td>
                    <td>статус</td>
                    <td class="finance">доход</td>
                    <td class="finance">расход</td>
                    <td class="finance">сальдо</td>
                    <td>всего транзакций</td>
                    <td>отменено букингов</td>
                    </thead>
                    <tr v-for="(item, index) in data.parkings" :key="index">
                        <td><router-link class="link2" :to="'/parking/' + item.id + '/transaction'">{{ item.address }}</router-link></td>
                        <td>{{ item.status }}</td>
                        <td class="finance">{{ item.income | finance }}</td>
                        <td class="finance">{{ item.outcome | finance }}</td>
                        <td class="finance" :class="{negative: item.diff < 0}">{{ item.diff | finance }}</td>
                        <td>{{ item.transaction_count }}</td>
                        <td>{{ item.cancelled }}</td>
                    </tr>
                </table>
            </div>
            <div class="grid _free mtop" v-if="data.parkings && data.parkings.length == 1">
                <router-link class="link2" :to="'/parking/' + data.parkings[0].id + '/transaction'">{{ data.parkings[0].address }}</router-link>
            </div>

            <Transactions type="user" :data="data" @updateData="updateData"></Transactions>
        </div>
    </form>
</template>

<script>
    import Transactions from '@/components/Transactions.vue'

    export default {
        props: ['status', 'data', 'pay_sum'],
        components: {
            Transactions
        },
        methods: {
            updateData (data) {
                this.$emit('updateData', data)
            },
        },
        created () {
            this.$emit('getData')
        }
    }
</script>